import * as React from "react";
import { useState } from "react";
import { Spinner } from "components/common";
import { useListRepoContent } from "security-app/hooks/useSigmaAPI";
import PanelHeader from "./PanelHeader";
import RuleItem from "./RuleItem";
import SearchRule from "./SearchRule";
import { WindowBody, WindowFooter } from "../styledComponents";
function LeftPanel({ repo, repos, loadingRepos, setRepo }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [repoPath, setRepoPath] = useState("");
  const { repoRules, loadingRepoRules } = useListRepoContent(repo == null ? void 0 : repo.id, repoPath, searchQuery);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    PanelHeader,
    {
      repoRules: repoRules || [],
      repo,
      repoPath,
      setRepoPath,
      setRepo
    }
  ), /* @__PURE__ */ React.createElement(WindowBody, null, loadingRepoRules || loadingRepos ? /* @__PURE__ */ React.createElement(Spinner, null) : (repoRules || repos).map((item) => /* @__PURE__ */ React.createElement(
    RuleItem,
    {
      key: `import-modal-${item.id}`,
      item,
      repoPath,
      setRepo,
      setRepoPath
    }
  ))), repo && /* @__PURE__ */ React.createElement(WindowFooter, null, /* @__PURE__ */ React.createElement(
    SearchRule,
    {
      query: searchQuery,
      searching: loadingRepoRules,
      onSearch: (query) => setSearchQuery(query)
    }
  )));
}
export default LeftPanel;
